import { AodRule } from '@app/modules/audit/modules/aod/aod.types';
import { Page } from '@app/components/page/Page';
import { defineMessage, useIntl } from 'react-intl';
import { AodBreadcrumbs } from '../../../components/AodBreadcrumbs';
import { aodRoutes } from '../../../routing/routes';
import { useAodRuleViewTabs } from '../hooks/useAodRuleViewTabs';
import { AodRuleActions } from './AodRuleActions';

const rulesTitleMessage = defineMessage({
  id: 'audit.aod.rules.title',
  defaultMessage: 'Reglas',
});

interface Props {
  rule: AodRule;
}

/**
 * Header for the AOD rule view page: title, breadcrumbs, path-based tabs, and actions.
 */
export function AodRuleViewHeader({ rule }: Props) {
  const { $t } = useIntl();
  const tabs = useAodRuleViewTabs(rule);

  return (
    <Page.Header
      title={rule.name}
      backBtn
      breadcrumbs={
        <AodBreadcrumbs
          items={[
            {
              href: aodRoutes.rules.gen(),
              content: $t(rulesTitleMessage),
            },
          ]}
        />
      }
      tabs={tabs}
      actions={<AodRuleActions rule={rule} />}
    />
  );
}
